import React from 'react'

import AlertCard from '../../../../Mantine/AlertCard'

import * as S from './styles.js'

export default function Alerta() {
  const message = (
    <S.AlertPlanoContainer>
      <span>
        <b>Cliente VIVO 2G</b> não será mais possível realizar pedidos de
        reposições de linhas 2G. Novas ativações e pedidos de reposição de
        linhas serão apenas com a tecnologia 4G.
      </span>
    </S.AlertPlanoContainer>
  )

  return <AlertCard type="warning" message={message} />
}
